import { inject, Injectable } from '@angular/core';
import { TablesWidthData } from 'app/models/reducers/table-store';
import { SapTablesFilters } from 'app/models/reducers/sap';
import { StorageService, StorageType } from './storage/storage.service';

@Injectable({ providedIn: 'root' })
export class TableStoreService {
  private readonly TABLE_WIDTH_DATA_STORAGE_KEY = 'ecn-table-width-data' as const;
  private readonly SAP_FILTERS_STORAGE_KEY = 'ecn-sap-filters-data' as const;
  private storageService: StorageService = inject(StorageService);

  setTableWidthData(data: TablesWidthData): void {
    this.storageService.set<TablesWidthData>(this.TABLE_WIDTH_DATA_STORAGE_KEY, data, StorageType.Local);
  }

  getTableWidthData(): TablesWidthData | null {
    return this.storageService.get<TablesWidthData>(this.TABLE_WIDTH_DATA_STORAGE_KEY, StorageType.Local);
  }

  putAllSapFiltersToStorage(filters: SapTablesFilters): void {
    this.storageService.set<SapTablesFilters>(this.SAP_FILTERS_STORAGE_KEY, filters, StorageType.Local);
  }

  getAllSapFiltersFromStorage(): SapTablesFilters | null {
    return this.storageService.get<SapTablesFilters>(this.SAP_FILTERS_STORAGE_KEY, StorageType.Local);
  }
}
